import ContactPageIcon from "@mui/icons-material/ContactPage";

// import { resources as TradeNetwork } from "../TradeNetwork";
import { resources as Edition } from "./EditionCatalog";
import { resources as ImportEdition } from "./ImportEdition";
import { resources as SubscriptionCompany } from "./SubscriptionCompany";
import { resources as ListSubscriptions } from "./Editions";
import { resources as Themes } from "./Theme";
import { resources as ImportThematicCatalog } from "./ImportThematicCatalog";

// import { resources as News } from "./News";
// import { resources as VacantPositions } from "./VacantPositions";
// import { resources as Auctions } from "./Auctions";

export const resources = {
  isMenu: true,
  name: "users-menu",
  title: "Абонаменти",
  icon: <ContactPageIcon />,
  permission: "editions",
  subMenu: [
    Edition,
    ListSubscriptions,
    SubscriptionCompany,
    ImportEdition,
    Themes,
    ImportThematicCatalog,
    // TradeNetwork,
    // News,
    // VacantPositions,
    // Auctions,
  ],
};
